import store from '@/app/store/store';
import { getShopNameApply } from '@/app/editor/iframe/atom/atom-spec/atom.funtions';

/**
 * check a feature/function want to apply for this shop
 * @param obj object need to test
 * @returns true: obj undifined or empty || false: nice object
 */
export const isObjectEmpty = (obj: any): boolean => {
  let result = false;
  if (!obj) {
    result = true;
  } else {
    if (Object.keys(obj).length === 0) {
      result = true;
    } else {
      result = false;
    }
  }
  return result;
};

/**
 * check a feature/function want to apply for this shop
 * @param key key want to check to apply funciton
 * @param dataTest this flag for auto test with Jest (static value) passing with format: {globalConfigs: object JSON, shopName: string}
 * @returns true: allow apply || false: not allow apply
 */
export const checkKeyValid = (key: string, dataTest?: any): boolean => {
  let result = false;
  let shopName, globalConfig;
  if (!isObjectEmpty(dataTest)) {
    shopName = dataTest.shopName;
    globalConfig = dataTest.globalConfigs;
  } else {
    shopName =
      store.getValue('__shop') && store.getValue('__shop').shopifyDomain ? store.getValue('__shop').shopifyDomain : '';
    globalConfig = store.getValue('__globalConfig');
  }
  if (globalConfig) {
    const keys = Object.keys(globalConfig);
    if (!keys || keys.length < 1 || !keys.includes(key)) {
      result = false;
    } else {
      const shopNames = globalConfig[key];
      if (shopNames && shopNames.length === 1 && shopNames[0] == '*') {
        result = true;
      } else if (getShopNameApply(shopName, shopNames)) {
        result = true;
      }
    }
  } else {
    result = false;
  }
  return result;
};

/**
 * get dynamic value from CMS
 * @param key key storage
 * @param dataTest this flag for auto test with Jest (static value) passing with format: {globalConfigs: object JSON, shopName: string}
 * @returns string value
 */
export const getGlobalValueString = (key: string, dataTest?: any): string => {
  let result = '';
  let globalConfig;
  if (!isObjectEmpty(dataTest)) {
    globalConfig = dataTest.globalConfigs;
  } else {
    globalConfig = store.getValue('__globalConfig');
  }
  if (globalConfig) {
    result = globalConfig[key];
  }
  return result;
};
